import { getFormatPrice, getCurrency, getPrice } from 'lib/utilities/Price';

const getInfoPrice = (locale, price) => {
  const currentPrice = price || 0;
  const formattedPrice = getFormatPrice(locale, currentPrice);
  const currency = getCurrency(locale.currency);
  const detailPrice = getPrice(formattedPrice, currency);
  const conf = {
    currentPrice: currentPrice,
    formattedPrice,
    detailPrice,
  };
  return currentPrice > 0
    ? {
        isComplimentary: false,
        ...conf,
      }
    : {
        isComplimentary: true,
        ...conf,
      };
};
export default getInfoPrice;
